// Generated by tools/extract-reference.mjs from the supplied HTML.
export const referenceCaseDetails = {
    "ao": {
        "className": "一对一定制",
        "enroll": "2026 年 6 月中旬",
        "before": {
            "l": "5.5",
            "r": "6.5",
            "w": "6.5",
            "s": "7.0",
            "o": "6.5"
        },
        "background": "7.27 机考写作上到 6.5，但听力发挥失常只有 5.5，和平时刷题稳定 6–6.5 的水平差距明显。出分当天决定报听力单科重考，用三周把听力拉回正常水平。",
        "path": [
            {
                "title": "课程阶段",
                "text": "写作 10 课时讲透 report 等大作文题型；听力 5 次课主攻 S4 填空：预判词性、圈画限定词，每课布置套题与语料库作业"
            },
            {
                "title": "考后复盘",
                "text": "7.27 出分当天逐题还原考场答案，定位 plants 单复数、age 词性等具体失分点，确认是答题习惯问题而非水平问题"
            },
            {
                "title": "单科重考",
                "text": "三周精听长难句 + 语料库背诵，考前发放当场考试预测资料，8 月听力单科重考回到 7.0"
            }
        ],
        "review": "她平时刷题稳定 6–6.5，考场只拿 5.5，复盘后定位在填空题词性预判和单复数两个习惯点。重考前只针对这两点练，加上语料库背诵，听力回到 7.0，总分 7.0。",
        "shots": [
            {
                "image": "/reference/uploads/x/s-243859.jpg",
                "category": "学员基础",
                "caption": "考后第一时间复盘：逐段回忆听力 P1–P3 发挥"
            },
            {
                "image": "/reference/uploads/x/s-348261.jpg",
                "category": "学习过程",
                "caption": "听力第 5 次课（Sherry）：S4 填空重点、课堂反馈与套题作业"
            },
            {
                "image": "/reference/uploads/x/s-274709.jpg",
                "category": "学习过程",
                "caption": "写作课后反馈（Beauty）：report 题型讲解、高分表达与默写作业"
            },
            {
                "image": "/reference/uploads/x/s-263720.jpg",
                "category": "老师指导",
                "caption": "听力逐题纠错：定位 plants 单复数、age 词性等失分点"
            },
            {
                "image": "/reference/uploads/x/s-341997.jpg",
                "category": "老师指导",
                "caption": "写作考后拆题：学员复述大作文思路，老师逐点确认"
            },
            {
                "image": "/reference/uploads/x/s-294793.jpg",
                "category": "班主任督学",
                "caption": "考前服务：发放 8 月三场雅思考试预测资料包"
            },
            {
                "image": "/reference/uploads/x/s-228081.jpg",
                "category": "提分报喜",
                "caption": "7.27 出分当天：写作上 6.5 报喜，同步决定听力单科重考"
            },
            {
                "image": "/reference/uploads/x/s-204883.jpg",
                "category": "提分报喜",
                "caption": "IDP 官网成绩页：总分 7.0，听力 7.0 / 阅读 6.5 / 写作 6.5 / 口语 7.0"
            },
            {
                "image": "/reference/uploads/x/s-216363.jpg",
                "category": "提分报喜",
                "caption": "出分时刻：学员群内报分致谢，「7 分啦！没白学！」"
            }
        ],
        "reportImage": "/reference/uploads/x/s-204883.jpg"
    },
    "li": {
        "className": "基础强化班",
        "enroll": "2026 年 3 月中旬",
        "before": {
            "l": "6.0",
            "r": "6.5",
            "w": "5.0",
            "s": "5.0",
            "o": "5.5"
        },
        "background": "第一次考试写作 5.0，语法错误集中在时态和冠词，段落之间缺少衔接。目标院校要求总分 7.0、单项不低于 6.0，只剩两个月。",
        "path": [
            {
                "title": "第 1–2 周",
                "text": "写作诊断 + 语法专项，先把反复犯的 12 个错误点清掉"
            },
            {
                "title": "第 3–6 周",
                "text": "每天一篇 AI 批改，老师每周挑两篇精改，重点练论证结构"
            },
            {
                "title": "第 7–8 周",
                "text": "全套模考三次，按考场节奏卡时间，口语补 Part 2 素材"
            }
        ],
        "review": "写作提分最怕改错方向。他的问题不在词汇量，而在论证展开，所以前两周只练结构不背模板，第五周开始分数就稳定在 6 分以上。",
        "shots": [],
        "reportImage": ""
    },
    "wang": {
        "className": "高分冲刺班",
        "enroll": "2026 年 5 月初",
        "before": {
            "l": "7.0",
            "r": "7.5",
            "w": "5.5",
            "s": "5.5",
            "o": "6.0"
        },
        "background": "工作日只有午休和通勤能学习，口语两次考试都是 5.5，答题内容偏短，遇到抽象话题容易卡住。",
        "path": [
            {
                "title": "第 1–4 周",
                "text": "通勤听精听，午休 20 分钟 AI 口语对练，先解决流利度"
            },
            {
                "title": "第 5–9 周",
                "text": "按话题库建自己的素材卡，老师每周一次真人模拟"
            },
            {
                "title": "第 10–12 周",
                "text": "全真模考 + 写作补短，考前一周只复盘错题"
            }
        ],
        "review": "他的听力阅读底子好，所以时间全压在口语和写作上。素材卡是关键，答题从三句话变成能讲满 45 秒。",
        "shots": [],
        "reportImage": ""
    },
    "chen": {
        "className": "一对一定制",
        "enroll": "2026 年 4 月上旬",
        "before": {
            "l": "5.5",
            "r": "5.0",
            "w": "5.0",
            "s": "4.5",
            "o": "5.0"
        },
        "background": "高三在读，每周只能空出四个晚上。首考总分 5.0，听力填空经常漏词，阅读做不完。",
        "path": [
            {
                "title": "第 1–3 周",
                "text": "听力精听打底，逐句听写练拼写和数字"
            },
            {
                "title": "第 4–7 周",
                "text": "阅读定位训练，限时完成三篇；口语背景素材同步积累"
            },
            {
                "title": "第 8–10 周",
                "text": "整套模考两次，考前把错题按题型归类重做"
            }
        ],
        "review": "基础薄的学生最需要固定节奏。他每次课后当天就在平台完成练习，十周下来听力从 5.5 到 7.0。",
        "shots": [],
        "reportImage": ""
    },
    "zhang": {
        "className": "高分冲刺班",
        "enroll": "2026 年 2 月底",
        "before": {
            "l": "7.5",
            "r": "7.0",
            "w": "6.0",
            "s": "6.0",
            "o": "6.5"
        },
        "background": "已有 6.5，但阅读判断题和标题匹配失分集中，时间常常不够。申请截止前只剩六周。",
        "path": [
            {
                "title": "第 1–2 周",
                "text": "阅读按题型拆解，先解决判断题的逻辑判断标准"
            },
            {
                "title": "第 3–4 周",
                "text": "限时三篇一组，错题按干扰项类型复盘"
            },
            {
                "title": "第 5–6 周",
                "text": "写作口语各两次批改，考前两天只看自己的错题本"
            }
        ],
        "review": "短周期提分要敢舍弃。我们只练阅读和写作，听力口语保持手感，六周后阅读从 7.0 到 8.5。",
        "shots": [],
        "reportImage": ""
    },
    "liu": {
        "className": "基础强化班",
        "enroll": "2026 年 1 月下旬",
        "before": {
            "l": "5.5",
            "r": "5.5",
            "w": "4.5",
            "s": "5.0",
            "o": "5.0"
        },
        "background": "交换项目要求总分 6.5，写作首考 4.5，作文靠模板拼接，论点和例子对不上。",
        "path": [
            {
                "title": "第 1–3 周",
                "text": "拆题训练，先写提纲不写全文，练观点和理由的对应"
            },
            {
                "title": "第 4–6 周",
                "text": "每周三篇 AI 批改 + 一篇精改，重点改语法准确度"
            },
            {
                "title": "第 7–9 周",
                "text": "两次全套模考，口语按话题做一轮突击"
            }
        ],
        "review": "模板依赖的学生要先停下来想清楚再写。九周里她的写作从 4.5 到 6.0，语法错误率下降了一半。",
        "shots": [],
        "reportImage": ""
    },
    "zhao": {
        "className": "一对一定制",
        "enroll": "2026 年 4 月底",
        "before": {
            "l": "4.5",
            "r": "4.5",
            "w": "4.5",
            "s": "5.0",
            "o": "4.5"
        },
        "background": "离开校园十余年，首考 4.5，听力跟不上语速，词汇量不足 3000。移民材料要求四个 6。",
        "path": [
            {
                "title": "第 1–5 周",
                "text": "词汇和语音同步，每天精听 15 分钟并跟读"
            },
            {
                "title": "第 6–10 周",
                "text": "四项轮转训练，老师每周一次一对一复盘"
            },
            {
                "title": "第 11–14 周",
                "text": "模考三轮，写作口语按评分标准逐条对照修改"
            }
        ],
        "review": "大跨度提分靠的是长期节奏，不是冲刺。十四周里他一次课没缺，听力从 4.5 到 7.0。",
        "shots": [],
        "reportImage": ""
    },
    "sun": {
        "className": "基础强化班",
        "enroll": "2026 年 4 月初",
        "before": {
            "l": "6.5",
            "r": "6.5",
            "w": "5.5",
            "s": "5.5",
            "o": "6.0"
        },
        "background": "口语两次都是 5.5，答题内容准备过度，一被追问就断。目标院校要求口语不低于 6.5。",
        "path": [
            {
                "title": "第 1–3 周",
                "text": "停用背诵稿，改练观点 + 理由 + 例子的三段式回答"
            },
            {
                "title": "第 4–6 周",
                "text": "每天 AI 对练 15 分钟，老师每周两次真人模拟追问"
            },
            {
                "title": "第 7–8 周",
                "text": "按最新题库过一轮 Part 2，写作补结构"
            }
        ],
        "review": "他的问题是准备过度。把背诵改成即时组织之后，口语从 5.5 到 7.0，考场上反而更自然。",
        "shots": [],
        "reportImage": ""
    },
    "zhou": {
        "className": "一对一定制",
        "enroll": "2026 年 4 月中旬",
        "before": {
            "l": "6.0",
            "r": "6.0",
            "w": "5.0",
            "s": "5.5",
            "o": "5.5"
        },
        "background": "在校课业紧，每周可用时间不固定。首考 5.5，阅读长难句理解慢，写作字数不够。",
        "path": [
            {
                "title": "第 1–4 周",
                "text": "长难句拆解，阅读改为每天两篇限时"
            },
            {
                "title": "第 5–8 周",
                "text": "写作从提纲到成文，每周两篇；听力保持精听"
            },
            {
                "title": "第 9–11 周",
                "text": "按考试节奏做三次全套模考，考前调整作息"
            }
        ],
        "review": "在校生的计划要能随时改。十一周里我们重排过三次周计划，阅读最终从 6.0 到 8.0。",
        "shots": [],
        "reportImage": ""
    },
    "wu": {
        "className": "高分冲刺班",
        "enroll": "2026 年 6 月底",
        "before": {
            "l": "8.0",
            "r": "8.0",
            "w": "6.0",
            "s": "6.5",
            "o": "6.5"
        },
        "background": "英语工作环境多年，听力阅读接近满分，写作卡在 6.0，口语表达偏口语化、缺少逻辑标记。",
        "path": [
            {
                "title": "第 1–3 周",
                "text": "考官视角逐句批改，对照评分标准定位失分档位"
            },
            {
                "title": "第 4–5 周",
                "text": "大作文按题型分类，练论证深度与句式多样性"
            },
            {
                "title": "第 6–7 周",
                "text": "口语精修 Part 3，写作两次全真限时"
            }
        ],
        "review": "高分段提分要对着评分标准改。他写作从 6.0 到 7.0，总分 8.0，靠的是七周里十四篇精改。",
        "shots": [],
        "reportImage": ""
    }
};
export const referenceMaterialDetails = {
    "speaking-new-topics": {
        "body": "每到换题季，口语板块就会出现同一种恐慌：新题出来了，之前准备的素材是不是全废了？答案是没有。换题季真正需要调整的不是素材，是练习的优先顺序。这篇讲清楚新题来了先做什么、什么时候该练、原来准备的东西怎么继续用。\n\n## 换题季是怎么回事\n\n雅思口语题库每年更换三次，分别在 1 月、5 月、9 月。每次换题会退掉一部分旧题、新增一部分新题，同时保留相当比例的高频题。也就是说，换题不是把题库清空重来，你之前准备的内容大部分仍然有效。\n\n需要注意的是换题的过渡期：换题季当月的前几场考试，抽到保留题的概率通常比新题高。所以如果你的考试就在换题季头一个月内，把精力压在保留题上是更划算的选择；考试在两个月之后，才需要认真准备新题。\n\n## 新题拿到手，先做的不是找答案\n\n大部分同学的第一反应是去搜「9 月新题参考答案」，背下来。这是最低效的做法，原因有两个：背的答案在考场上被追问一句就接不住；而且考官对背诵痕迹非常敏感，一旦判断为背稿，流利度和连贯性两项都会压分。\n\n正确的第一步是归类。Part 2 的题目无论怎么换，都跑不出四大类：人物、地点、事件、物品。拿到新题清单先按这四类分好，你会发现十几道新题其实只落在几个熟悉的框里。\n\n第二步是看题目要求答什么。同样是人物题，「描述一个鼓舞你的人」和「描述一个你想更多了解的人」，落点完全不同。把每道题的核心落点用一句话写下来，比背整段答案有用得多。\n\n## 一套素材串多道题\n\n这是换题季最省力的方法：同一段亲身经历，可以覆盖当季多道 Part 2 题目。\n\n举个例子。假设你有一段「大学时和朋友骑车去郊区」的经历，它可以同时用来回答：描述一次难忘的旅行、描述一个你喜欢的户外活动、描述一个和朋友一起做的事、描述一个让你放松的地方。四道题，一套素材，你要做的只是根据题目落点调整强调的侧重——旅行题强调过程，地点题强调环境，朋友题强调互动。\n\n这样准备的好处是：素材是你自己的，说起来自然、细节真实、被追问也答得上来。考场上不必临时编，这是流利度最大的保障。\n\n## 练到什么程度算准备好了\n\n三个自检标准，比「背没背下来」实用得多：\n\n能不能说满时长。Part 2 要求说满 2 分钟。多数人的问题不是没话说，是说了 40 秒就把要点讲完了。解决办法是在每个要点后面加一层细节：什么时候、和谁、当时什么感觉。\n\n被追问会不会慌。Part 2 结束后考官通常会追问一到两句，Part 3 更是全程追问。如果你的答案是背的，追问就是塌方点。用自己的经历，追问反而是加分机会。\n\n听起来像不像在说话。录一段自己回听，如果听起来像在朗读，说明还停留在背稿阶段。\n\n《9 月 Part 2 新题清单》逐题整理新增与保留题目，每题给出审题要点、可迁移的素材方向和一个 6.5 分示范框架（是框架，不是逐字稿）。免费领取，扫码加规划老师回复「新题」。\n\n拿到清单之后，可以直接在萝卜雅思小程序里按新题练——P1/P2/P3 全题库自选话题，说完 AI 会像考官一样追问，逐句纠错并给出发音、流利度、词汇、语法四项评分。新用户注册即送 20 分钟。",
        "included": [
            "新题清单 — 9 月新增 Part 2 题目 18 道，逐题标注考频",
            "审题要点 — 每题 3 行内讲清答什么、避开什么",
            "素材方向 — 按人物 / 地点 / 事件 / 物品四大类给可迁移素材",
            "示范框架 — 每题一个 6.5 分答题框架，不是逐字稿",
            "配套练习 — 扫码进小程序按新题清单直接练，练完出报告"
        ],
        "suitableFor": [
            "9–12 月要考口语",
            "目标 6.0–7.0",
            "Part 2 说不满 2 分钟"
        ],
        "howToClaim": [
            "扫码加规划老师",
            "回复「新题」",
            "收 PDF + 题库入口"
        ]
    },
    "speaking-question-bank": {
        "body": "几乎每个备考雅思的同学手里都有一份口语题库，但拿到题库之后的做法差别很大，出分也差很多。题库本身没有价值，用法才有。这篇讲清楚三个部分各自该怎么练。\n\n## 题库不是用来背的\n\n先说清楚为什么不建议背。\n\n考官判断一个答案是不是背的，主要看三点：语速忽快忽慢（背的部分流利、自己说的部分卡顿）、用词和话题不匹配（简单话题里突然冒出学术词）、被追问后答不上来。三点中任意一点触发，流利度与连贯性这一项就会被压。\n\n更现实的问题是：Part 1 有几十个话题、每个话题三四道题，Part 3 完全无法预测。背得完的题量，和考场上会被问到的题量，不是一个数量级。\n\n题库的正确用途是：让你知道会考什么类型的问题，然后针对类型准备素材和表达方式。\n\n## Part 1 —— 练「接得住」，不练「说得多」\n\nPart 1 是热身，问的都是日常话题：住的地方、工作学习、爱好、天气、购物。考官的期待是自然对话，不是演讲。\n\n这部分的常见错误是答得太长。一道题答 40 秒，考官会打断你，节奏一乱后面就慌。每题两三句、15–20 秒是合适的长度：先直接回答，再给一个理由或细节。\n\n练法建议：把当季 Part 1 话题按「能不能一秒反应过来」分成三类。反应得快的跳过，卡壳的挑出来，每个准备两三句自然的回答。重点是准备表达方式，不是准备内容。\n\n## Part 2 —— 练素材复用，不练逐字稿\n\nPart 2 给一分钟准备、两分钟独白。最实际的准备方式是把自己的真实经历整理成几套可迁移的素材，而不是为每道题写一篇稿子。\n\n按人物、地点、事件、物品四类各准备两三段经历，每段经历确保有：具体的时间地点、具体的人、一个转折或细节、一句你的感受。有了这些，绝大多数 Part 2 题目都能现场组装出来。\n\n准备的那一分钟不要写句子，写关键词——三到五个词，够撑起两分钟的结构就行。写句子会导致你在读，而不是在说。\n\n## Part 3 —— 练观点展开，不练答案\n\nPart 3 是抽象讨论，考官会追问、会反驳、会让你比较。这部分无法背，只能练展开能力。\n\n一个可操作的框架：观点 → 原因 → 例子 → 让步。四步说完通常就是 30–40 秒，长度刚好。练的时候不用管话题是什么，就用这个框架反复套，练到不用想就能展开。\n\n另外，Part 3 允许你说「这个我没太想过」，然后现场推理。考官考的是英语能力，不是知识储备，诚实地边想边说，比硬凑一段假观点分更高。\n\n## 一天练多久，怎么判断练到位了\n\n每天开口 20 分钟，比周末突击两小时有效得多。口语是肌肉记忆，靠频次不靠单次时长。\n\n三个自检标准：Part 1 能不能不假思索接上、Part 2 能不能说满两分钟不重复、Part 3 被追问一句还能不能接着说。三个都做到，6.5 就有把握了。\n\n最难的是找人陪你练。这也是口语最容易被搁置的原因——写作可以自己写，听力阅读可以自己刷，口语没人对练就只能干背。\n\n《当季口语题库完整版》包含 Part 1、Part 2、Part 3 全部当季话题，每个话题配示例答案与素材方向。免费领取，扫码加规划老师回复「题库」。\n\n领到题库之后，可以直接在萝卜雅思小程序里按题库练：自选话题开口作答，AI 会像考官一样追问，说完逐句指出语法和发音问题，并给出四项评分与问题清单。新用户注册即送 20 分钟。",
        "included": [
            "Part 1 题库 — 当季全部日常话题，每题配自然回答示范",
            "Part 2 题库 — 人物 / 地点 / 事件 / 物品四类全覆盖",
            "Part 3 题库 — 高频追问方向与观点展开框架",
            "素材整理模板 — 把真实经历拆成可迁移素材的填写表",
            "配套练习 — 小程序内按题库开口练，练完出评分报告"
        ],
        "suitableFor": [
            "备考全阶段",
            "目标 6.0–7.5",
            "想按题库系统练"
        ],
        "howToClaim": [
            "扫码加规划老师",
            "回复「题库」",
            "收题库 + 小程序入口"
        ]
    },
    "writing-task2-samples": {
        "body": "大部分同学下载范文之后只做一件事：从头读一遍，觉得「写得真好」，然后关掉。两周后写作还是 5.5。问题不在范文，在读法——范文的价值不是让你欣赏，是让你拆。这篇讲清楚该拆什么、怎么拆，并给出一篇完整示范。\n\n## 为什么背了范文，作文分还是不动\n\n考官评分看四项：任务回应（TR）、连贯与衔接（CC）、词汇资源（LR）、语法多样性（GRA）。背范文只可能提升 LR 里很小的一部分——一些高级词和句型，而且往往用错场合，反而在 CC 上扣分。\n\n更常见的情况是：背了一堆 With the development of society 这类开头，考官一眼看出是模板，TR 直接压在 5.5。模板化表达在四项里没有一项能加分，却在两项上扣分。\n\n真正决定 6.5 与 5.5 差距的，是论证有没有展开。5.5 的作文通常每段只有观点没有例证，6.5 的作文每个观点后面跟着一个具体场景或数据。这一点范文里全都有，但你读的时候没在找它。\n\n## 范文的三种正确读法\n\n第一种：拆结构，不看内容。拿到一篇范文，先只看每段第一句，把四段的主题句抄下来。你会发现好范文的四句主题句连起来就是一个完整的论证链：立场 → 理由一 → 理由二 → 收束。练十篇，你对 Task 2 的结构感就成了肌肉记忆。\n\n第二种：拆展开方式，不背句子。挑一个主体段，看作者在主题句之后做了什么——是举了一个具体人的例子？给了一组数据？做了一次因果推演？把这个「展开动作」记下来。中国学生写作最大的问题就是只有观点没有展开，而展开方式是可以数出来的，常用的不超过五种。\n\n第三种：拆同义替换，不抄词表。看作者怎么把题目里的词换掉。比如题目是 students should focus more on practical skills，范文里出现的是 hands-on ability、workplace-ready competence。这种替换是有场景的，比背单词表管用得多。\n\n## 一篇示范：拆给你看\n\n题目：Some people think universities should provide graduates with the knowledge and skills needed in the workplace. To what extent do you agree or disagree?\n\n引言段：改写题目背景一句 + 明确立场一句。不写「随着社会发展」这类空话，直接进入争议本身。\n\n主体段一（主题句）：Practical training makes graduates employable from day one. 展开动作 = 具体职业场景。写一个学计算机的学生和一个只学理论的学生毕业后的差别，落到「能不能第一周就交付工作」这个具体点上。\n\n主体段二（主题句）：However, universities that abandon theory produce narrow specialists. 展开动作 = 因果推演。技能会过时，理论决定学习新技能的速度，五年后差距反而拉开。\n\n结论段：不重复前面的句子，给一个折中判断——课程设置应以理论为骨、实践为翼。\n\n注意这篇里没有任何生僻词。6.5 分不靠难词，靠每段都把话说完。\n\n## 常见的三个扣分点，范文里都能找到反例\n\n- 例证不具体：写了「很多人因此找到工作」，没有写是谁、什么工作、为什么。TR 扣分。\n\n- 让步缺失：全文一边倒，没有承认对方观点的价值。CC 与 TR 同时扣分。\n\n- 词汇重复：一篇里 important 出现五次。LR 扣分，而这是最容易改的一项。\n\n这三点你在自己的作文里未必看得出来，但交给 AI 批改会逐句标出来——萝卜的写作平台会把重复出现的错误自动归入你的写作错因库，考前一次性清掉。\n\n30 篇范文按题型分类，每篇标注得分点与可复用句式，另附逐段批注说明「这里为什么加分」。免费领取，扫码回复「范文」。\n\n想知道自己现在的作文卡在哪一项，可以先做一次免费 AI 批改，30 秒出四维评分与逐句批注。",
        "included": [
            "30 篇范文 — 按题型分类，覆盖同意与否、利弊、双边讨论等",
            "逐段批注 — 每段标注「这里为什么加分」",
            "结构拆解 — 四段主题句提炼，看清完整论证链",
            "展开方式 — 常用五种论证展开动作归纳",
            "同义替换 — 题目关键词的场景化替换对照"
        ],
        "suitableFor": [
            "写作 5.5–6.0",
            "目标 6.5",
            "写完不知道哪里不对"
        ],
        "howToClaim": [
            "扫码加规划老师",
            "回复「范文」",
            "收 PDF + AI 批改入口"
        ]
    },
    "writing-band-report": {
        "body": "写作 6 分和 6.5 分之间只差半分，但很多人考三次都停在 6.0。原因是这半分不来自「写得更好」，而来自不再犯某几个具体的错。这篇按四项评分标准逐条讲清楚，卡在 6 分的作文通常是在哪里丢的分。\n\n## TR 任务回应 —— 最常见的失分是「只给观点，不给例证」\n\n6 分的典型特征是：每段都有清晰的观点，但观点后面直接跟下一个观点。考官看到的是一份「论点清单」，不是「论证」。\n\n6.5 的要求很朴素：每个主体段至少有一个具体的支撑。可以是一个具体的人、一件具体的事、一个具体的数据。不需要真实，需要具体——「我表姐去年从会计转行做数据分析，三个月上手」，比「很多人通过学习新技能实现转型」高一档。\n\n另一个 TR 扣分点是跑偏：题目问的是 to what extent do you agree，你写成了利弊分析。这一项一旦偏，上限就锁死在 5.5–6。\n\n## CC 连贯衔接 —— 连接词堆砌反而扣分\n\n很多同学以为多用 Firstly / Moreover / Furthermore 就能提 CC，实际相反。考官报告里反复出现的一句评价是「连接词使用机械」。\n\n6.5 的连贯来自内容本身的推进：段落主题句之间有逻辑关系，段内每句话都在推进上一句，而不是并列堆放。一个可操作的自检方法：把段落里的连接词全部删掉，如果句子之间还读得通，说明连贯是真的；如果读不通，说明连贯一直是连接词假装出来的。\n\n段落无主题句是另一个高频扣分点。每段第一句必须能单独概括这一段。\n\n## LR 词汇资源 —— 重复和中式表达\n\nLR 卡在 6 分最常见的两个原因：\n\n同一个词反复出现。important 一篇出现五次、people 出现八次。这不需要背新词，把其中几处换成 crucial / essential / vital，或者把 people 换成 individuals / the public，就能改善。\n\n中式表达。这几个几乎每篇都会出现：\n\n- in nowadays society → in today's society\n\n- easy to find jobs（easy 不能直接修饰人）→ make it easier for students to find jobs\n\n- With the development of society → 删掉，直接进入话题\n\n## GRA 语法多样性 —— 句式单一比语法错误更致命\n\n6 分作文往往语法错误不多，但通篇都是简单句和 and 连接的并列句。6.5 要求的是句式有变化：定语从句、状语从句、分词结构、倒装各出现一两次即可，不需要复杂到炫技。\n\n而真正扣分的语法错误集中在三类：主谓一致（A student who master → masters）、时态不一致、冠词缺失。这三类占了绝大多数扣分，而且都是可以通过刻意检查改掉的。\n\n## 怎么知道自己丢在哪一项\n\n自己看不出来是正常的——问题恰恰在于你觉得写对了才那么写。可行的做法有两个：找老师逐句批改，或者用 AI 批改按四项标准逐条标出扣分点。\n\n萝卜的写作平台会给出 TR / CC / LR / GRA 四项独立评分，标出原文每一处问题并给出可直接替换的改法；反复出现的同类错误会自动沉淀成你的写作错因库，考前集中清一遍。\n\n《考官报告扣分点解读》对照官方评分标准，拆解三个最常见的扣分原因与改法，免费领取，扫码回复「扣分」。",
        "included": [
            "TR 任务回应 — 只给观点不给例证的三种典型表现",
            "CC 连贯衔接 — 连接词堆砌与段落无主题句的改法",
            "LR 词汇资源 — 高频重复词替换表与中式表达对照",
            "GRA 语法多样性 — 三类高频语法错误自查清单",
            "考前自查表 — 交卷前 10 分钟逐项过一遍"
        ],
        "suitableFor": [
            "写作稳定 6.0",
            "考过两次以上",
            "目标 6.5–7.0"
        ],
        "howToClaim": [
            "扫码加规划老师",
            "回复「扣分」",
            "收 PDF + AI 批改入口"
        ]
    },
    "cambridge-guide": {
        "body": "剑桥雅思真题是备考中最重要的材料，也是被浪费得最厉害的材料。常见的用法是：做一套、对答案、看看错了几道、换下一套。这样刷完十几本，提分很有限。真题的价值有八成在做完之后，这篇讲清楚该怎么用。\n\n## 从哪本开始 —— 建议倒着刷\n\n剑 4 到剑 19 跨度接近二十年，越早的册子和现在的考情差距越大：文章题材偏旧、听力语速偏慢、题型配比也和现在不同。\n\n建议从最新的几本开始，倒序往前。如果时间紧，只刷最近的五六本比从剑 4 一路刷过来更有效率。早期册子可以留作基础期的语感材料，不必当作模考。\n\n另外提醒一点：真题的作用是暴露问题，不是刷量。做四套认真复盘，胜过做十套只对答案。\n\n## 一套题的正确用法 —— 做 1 小时，复盘 2 小时\n\n这个比例听起来夸张，但它是提分效率最高的配置。\n\n做题时严格按考试条件：不查词、不暂停、不回听、计时。做完先自己检查一遍，标出「猜的」和「不确定的」题——这些题即使做对了，也要当错题处理，因为下次不一定蒙对。\n\n然后进入复盘。复盘不是看答案解析，是回到原文找到那一句，弄清楚自己当时为什么没做对。原因通常只有几类：没听清、没定位到、同义替换没识别、时间不够。把原因归类记下来，比记住这道题的答案有用得多。\n\n## 四科各自的复盘重点\n\n听力：错题必须回到原文录音，找到答案出现的那一秒，重听三遍。判断是没听出来（发音问题）还是听出来了没反应过来（词汇问题）。前者练精听，后者补场景词。\n\n阅读：把题干里的关键词和原文中对应的表达画出来，标出同义替换关系。阅读的绝大多数错题都是替换没识别出来，积累这些替换对，比背单词表提分快。\n\n写作：真题的价值在于题目和范文。自己先写，写完对照范文，重点看两件事——结构是否完整、论证是否展开。如果没有人给你批改，至少要做这一步对照。\n\n口语：把题目录下来自己答一遍，回听。你会听到自己平时意识不到的问题：口头语过多、停顿太长、同一个词反复用。\n\n## 什么时候开始严格限时\n\n前两套不建议限时。基础期限时只会让你手忙脚乱，无法暴露真实问题。前两套的任务是熟悉题型和节奏。\n\n从第三套开始严格计时，尤其是阅读——60 分钟三篇文章，时间分配失控是丢分的主因之一。到备考后期，至少做两次完整的全真模考：四科连着做完，中间不休息，感受真实的体力消耗。\n\n## 真题刷完了怎么办\n\n很多同学在考前一个月遇到这个问题：真题刷完了，还有半个月，练什么？\n\n答案是回到错因，不是找新题。把之前所有错题按原因归类，看看哪一类反复出现，针对那一类专项练。写作和口语则应该增加频次——这两科是唯二能通过刻意练习在短期内提分的科目，而且不受「题做完了」的限制。\n\n《剑桥真题精讲笔记》为萝卜教研组自编，逐套整理高频考点、易错题与同义替换对照，不含剑桥原版内容。免费领取，扫码加规划老师回复「真题」。\n\n写作和口语的复盘最需要外部反馈。萝卜的 AI 写作平台可以对你的作文按官方四项标准打分并逐句指出问题，口语小程序可以按当季题库对练并给出评分报告——两个平台都不需要先留手机号。",
        "included": [
            "使用顺序 — 剑 4–19 该从哪本开始、怎么往前排",
            "复盘方法 — 做题 1 小时 / 复盘 2 小时的具体做法",
            "四科重点 — 听说读写各自的复盘动作清单",
            "限时时机 — 什么时候开始计时与安排全真模考",
            "教研笔记 — 萝卜教研组自编高频考点与易错题整理"
        ],
        "suitableFor": [
            "手里有真题不会用",
            "刷完题不涨分",
            "备考中后期"
        ],
        "howToClaim": [
            "扫码加规划老师",
            "回复「真题」",
            "收教研组自编笔记"
        ]
    },
    "listening-intensive": {
        "body": "听力是四科里最容易「假努力」的一科：戴着耳机听两小时，感觉很充实，分数纹丝不动。原因是泛听只能维持语感，不能修复问题。这篇讲清楚精听该怎么做，以及听力丢分的三个真实原因。\n\n## 精听和泛听的区别\n\n泛听是「听个大概」，用于保持语感，适合通勤、洗漱这类碎片时间。精听是「一个词都不放过」，用于找出你到底听不出什么。\n\n多数同学的备考里只有泛听，没有精听。结果是：你一直在用已经会的部分反复练习，听不出来的那部分永远听不出来。分数因此长期停在同一档。\n\n一个判断标准：如果你听完一段材料，说不出自己具体哪几个词没听出来，那刚才做的就是泛听。\n\n## 五步精听法\n\n第一步，盲听。不看任何文本，正常速度听一遍，做题或者复述大意。\n\n第二步，逐句听写。一句一句听，写下来，可以反复听但不看文本。写不出来的地方留空。这一步最痛苦，也最有效。\n\n第三步，对照文本。打开逐句文本，把自己写错和留空的地方标出来。重点不是订正，是分类：这个词是不认识？还是认识但没听出来？还是听成了别的词？\n\n第四步，跟读。对着文本跟读三遍，重点模仿刚才没听出来的那几处的发音。听不出来往往是因为自己念得不对。\n\n第五步，隔天复听。第二天再听一遍同一段，检查昨天标出来的地方现在能不能听出来。\n\n一段三分钟的材料，完整走完五步大约需要 20–25 分钟。每天一段，比听两小时有效得多。\n\n## 三个最常见的听力障碍\n\n连读与吞音。英语实际发音和单词表上的读音差别很大：want to 听起来是 wanna，a lot of 中的 of 几乎消失，句尾辅音经常被吞掉。这类问题只能靠跟读修复，看再多单词也没用。\n\n数字与拼写。Section 1 的填空经常考电话、日期、门牌号、人名拼写。这部分是纯熟练度，专项练两周就能明显改善，性价比极高。\n\n同义替换。题干说 accommodation，录音里说的是 place to stay。听出来了但没反应过来，等意识到时录音已经过去了。解决办法是提前预读题干，把可能被替换的词圈出来。\n\n## 每天练多久合适\n\n15 分钟精听 > 1 小时泛听。精听消耗注意力，超过 30 分钟效率会明显下降，不如拆成两次。\n\n节奏建议：每天一段精听（15–25 分钟）+ 碎片时间泛听。持续三周就能感觉到变化，这是四科里反馈最快的一科。\n\n《听力精听训练包》包含 30 段真题音频与逐句文本，按场景分类（校园、租房、旅行、讲座等），可直接按五步法使用。免费领取，扫码加规划老师回复「精听」。",
        "included": [
            "30 段音频 — 按校园、租房、旅行、讲座等场景分类",
            "逐句文本 — 每段配对照文本，便于听写核对",
            "五步精听法 — 盲听 → 听写 → 对照 → 跟读 → 复听",
            "障碍清单 — 连读吞音、数字拼写、同义替换专项",
            "打卡表 — 每日 15–25 分钟的执行记录表"
        ],
        "suitableFor": [
            "听力停在 5.5–6.5",
            "泛听多精听少",
            "每天能挤出 20 分钟"
        ],
        "howToClaim": [
            "扫码加规划老师",
            "回复「精听」",
            "收音频 + 逐句文本"
        ]
    },
    "reading-paraphrases": {
        "body": "很多同学阅读做不完，第一反应是「我读得太慢了」，于是去练速读。方向错了。雅思阅读考的不是阅读速度，是定位能力，而定位的核心是识别同义替换。这篇讲清楚该练什么。\n\n## 阅读的本质是找同义替换\n\n雅思阅读几乎不会把题干里的词原样放在原文里。出题人做的事就是：把原文的表达换一种说法放进题干，考你能不能认出来。\n\n举一个典型例子。题干问：The company reduced its spending on advertising. 原文里写的是：The firm cut back on its promotional budget. 没有一个词是重复的，但说的是同一件事。认出这组对应关系需要两秒，认不出就会在这道题上耗五分钟。\n\n所以阅读做不完的真正原因通常不是读得慢，是在文章里反复扫描却认不出目标句。\n\n## 同义替换的四种类型\n\n单词级替换：最基础的一类。reduce → cut、important → crucial、buy → purchase。这类靠积累。\n\n短语级替换：一个词换成一个短语，或者反过来。increase → go up、cause → give rise to、tolerate → put up with。这类是中国学生最容易漏的，因为短语动词往往由简单词组成，看起来眼熟但组合起来意思变了。\n\n词性转换：原文用名词，题干用动词；原文用形容词，题干用副词。The rapid growth of... → ...grew rapidly。这类替换会改变句子结构，定位难度更高。\n\n句式改写：主动变被动、肯定变双重否定、因果关系换个方向表述。这类最难，通常出现在难度较高的判断题里。\n\n## 怎么积累才有用\n\n按场景归类，不按字母顺序背。雅思阅读的题材是有限的：环境、教育、科技、健康、商业、历史、动植物。按场景整理这个场景下的高频替换对，比背一份按 A 到 Z 排列的词表有效得多——因为你在考场上是在特定语境里认词。\n\n从自己的错题里积累。每做完一套真题，把错题对应的题干和原文句子并排抄下来，画出替换关系。这样积累出来的替换对，全部是你真实认不出来的，针对性最强。\n\n积累的形式是「对」，不是「词」。记 reduce 没有意义，要记 reduce ↔ cut back on 这一组，并且记下它出现在什么句子里。\n\n## 定位速度怎么练\n\n三个可执行的动作：\n\n先读题干，圈出关键词。优先圈那些不太可能被替换的词——人名、地名、年份、数字、专有名词。这些是定位锚点。\n\n再回文扫描，不要逐词读。眼睛在文中找的是刚才圈出的锚点，找到之后再仔细读那一句和前后各一句。\n\n判断题特别注意 NOT GIVEN。原文没提到的信息不能靠常识推断。很多错题不是没读懂，是自己脑补了原文没说的内容。\n\n《阅读同义替换 500 组》按七大场景归类整理，每组附出处例句，可直接打印背诵。免费领取，扫码加规划老师回复「替换」。",
        "included": [
            "500 组替换 — 按环境、教育、科技等七大场景归类",
            "例句出处 — 每组附真题例句，看清使用语境",
            "四种类型 — 单词级、短语级、词性转换、句式改写",
            "定位方法 — 关键词圈画与回文扫描的具体步骤",
            "判断题专项 — NOT GIVEN 的常见误判情形"
        ],
        "suitableFor": [
            "阅读做不完",
            "判断题失分多",
            "目标 6.5–7.5"
        ],
        "howToClaim": [
            "扫码加规划老师",
            "回复「替换」",
            "收 PDF · 可打印"
        ]
    },
    "eight-week-plan": {
        "body": "「8 周能不能考到 6.5」没有统一答案，取决于起点。四级 500 分左右、有一定语法基础的同学，8 周到 6.5 是合理目标；零基础从头开始，8 周更现实的目标是 5.5–6。先确认起点，再谈计划，否则计划表只是一张让人焦虑的纸。\n\n## 前两周 —— 摸底与补漏，不要急着刷题\n\n第一周先做一次完整摸底，四科各测一次，知道自己现在大概什么水平、哪一科拖后腿。这一步很多人跳过，直接开始刷剑桥真题，结果是听力和阅读在做，写作和口语一动不动，八周后单项瘸腿。\n\n第一到第二周的主要任务是语法和词汇扫盲：把基础语法结构过一遍（时态、从句、主谓一致），词汇按雅思场景分类过一轮，不背词表背场景词。同时每天精听 15 分钟，先建立听感。\n\n## 第三到第四周 —— 分项方法，每类题型讲透一次\n\n这两周是方法输入期，四科分开推进：\n\n- 听力：按题型练（填空、选择、地图、配对），每种题型先弄清楚出题逻辑再刷量\n\n- 阅读：重点练同义替换识别和定位，不要逐词读文章\n\n- 写作：Task 2 先固定四段结构，把审题和列提纲练熟，再练成段\n\n- 口语：Part 1 先把当季高频话题过一遍，每个话题准备两三个可迁移素材\n\n这个阶段的量不必大，每种题型练到「知道该怎么下手」就够了。\n\n## 第五到第六周 —— 套题与精练交替\n\n开始做完整套题，但关键在做完之后。做题 1 小时，复盘 2 小时，这个比例才有效。听力错题要回到原文找到那一句、弄清楚为什么没听出来；阅读错题要标出题干与原文的同义替换点。\n\n写作这两周要形成节奏：每周至少两篇完整作文，每篇都要有反馈。没有反馈的写作练习，写十篇和写一篇效果差不多——因为你会把同一个错误重复十遍。口语每天开口 20 分钟，重点是流利度，不追求用难词。\n\n## 第七到第八周 —— 模考与考前调整\n\n第七周做两次全真模考，严格计时，按真实考试顺序连着做完。模考的目的不是估分，是发现体力和时间分配问题。\n\n第八周不再学新东西，只做三件事：复盘错因库、口语过当季题库、保持每天的听力手感。考前三天停止高强度练习。\n\n## 这份计划表怎么用\n\n计划表按周拆到每天的四科任务量，可直接打印贴在桌前。但它是通用版——你的起点和薄弱项决定了哪几周需要加码。\n\n建议先花 8–10 分钟做一次免费入门测评，12 道题覆盖听说读写，测完给出四科预测分和薄弱点分析，再照着计划表调整每周的任务配比。\n\n《8 周首考 6.5 备考计划表》按周拆解四科任务量，可打印执行，免费领取，扫码加规划老师回复「计划」。",
        "included": [
            "逐周任务 — 8 周拆到每天的四科任务量",
            "阶段目标 — 每两周一个可验收的节点",
            "四科配比 — 听说读写的时间分配建议",
            "模考安排 — 全真模考的时间点与复盘要求",
            "可打印版 — A4 单页，贴在桌前逐日打勾"
        ],
        "suitableFor": [
            "首考考生",
            "备考周期 8 周左右",
            "目标 6.5"
        ],
        "howToClaim": [
            "扫码加规划老师",
            "回复「计划」",
            "收表格 + 测评入口"
        ]
    }
};
//# sourceMappingURL=reference-data.js.map